import { combineReducers } from "redux";
import produce from "immer";
import workflowReducer from "./workflow";
import db4MailerReducer from "../../components/Db4Mailer/db4Slice";
import appReducer from "../../components/appSlice";
import workflow from "../../components/Workflow/workflowSlice";
import medicalResults from "../../components/Workflow/medicalResultsSlice";
import userReducer from "./user";
import appointmentRequests from "../../components/AppointmentRequestTable/appointmentRequestSlice";
import rawReferralsSlice from "../../pages/ReferralInbox/rawReferralSlice";
import rawReferralsAISlice from "../../pages/ReferralInbox/rawReferralAISlice";
import errorResultSlice from "../../pages/ErrorResultsInbox/errorResultSlice";
import errorReportSlice from "../../pages/ErrorReportsInbox/errorReportSlice";
import aiErrorResultSlice from "../../pages/ErrorResultsInbox/aiErrorResultSlice";

export const rootReducer = combineReducers({
  app: appReducer,
  db4Mailer: db4MailerReducer,
  workflow,
  medicalResults,
  appointmentRequests,
  rawReferrals: rawReferralsSlice.reducer,
  rawReferralsAI: rawReferralsAISlice.reducer,
  errorResults: errorResultSlice.reducer,
  aiErrorResults: aiErrorResultSlice.reducer,
  errorReports: errorReportSlice.reducer,
  user: userReducer,
});

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING": {
      return produce(state, (draft) => {
        draft.isLoading = action.payload.isLoading;
        draft.loadingText = action.payload.loadingText;
      });
    }

    case "SET_ERROR": {
      return produce(state, (draft) => {
        draft.hasError = action.payload.hasError;
        draft.errorText = action.payload.errorText;
      });
    }

    case "SET_SELECTED_TAB_ID": {
      return produce(state, (draft) => {
        draft.selectedTabId = action.payload.selectedTabId;
      });
    }

    case "SET_PATIENT_LIST":
    case "SET_SELECTED_PATIENT_ID": {
      return workflowReducer(state, action);
    }

    default: {
      throw new Error();
    }
  }
};

export default reducer;
